"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expiredTokenErrorHandlingContext = void 0;
var refresh_token_default_strategy_1 = require("./refresh-token-default-strategy");
var privateStrategy = refresh_token_default_strategy_1.refreshTokenDefaultStrategy;
var setStrategy = function (strategy) {
    privateStrategy = strategy;
};
var handleTokenRefresh = function () {
    return privateStrategy.execute();
};
exports.expiredTokenErrorHandlingContext = {
    handleTokenRefresh: handleTokenRefresh,
    setStrategy: setStrategy,
};
